export const TWO_FACTOR_AUTH_SETUP_FEATURE_NAME = 'twoFactorAuthSetupState';
